import translate      	from '../../../../utils/translate'

export const metahelpers = {
    getGamePackageMetaObject(matchData, pageType, edition) {
      const domain = edition.domain || ''
      const hostInfo = domain.replace('www.','').replace('espn','ESPN');
      let gamePackageMetaObject = {}
      let fullScore = matchData.fullScore
      let homeTeamName = matchData.homeTeamName
      let homeTeamAbbr = matchData.homeTeamAbbr
      let awayTeamName = matchData.awayTeamName
      let awayTeamAbbr = matchData.awayTeamAbbr
      let matchNum = matchData.matchNum
      let matchSummary = matchData.matchSummary, matchSummaryText
      let gameState = matchData.gameState
      let matchYear = matchData.matchYear
      let leagueName = matchData.leagueName
      let isTournament = matchData.isTournament
      let matchWinner = matchData.matchWinner
      let matchLoser = matchData.matchLoser
      let matchName = matchData.matchName
      let translatedKeyObjectForGamePackage = {}
  
      let pagetypeLower = pageType.toLowerCase()
  
      if(isTournament) {
        switch(pagetypeLower) {
          case 'game':
            if(gameState === 'pregame') {
              translatedKeyObjectForGamePackage = {
                title : {
                  key : 'meta.title.cricket.multination.gamepackage.game.pre',
                  homeTeamName : homeTeamName,
                  awayTeamName :  awayTeamName,
                  leagueName: leagueName,
                  matchYear: matchYear,
                  matchNum: matchNum,
                  domain: hostInfo
                },
                description : {
                  key : 'meta.description.cricket.multination.gamepackage.game.pre',
                  homeTeamName : homeTeamName,
                  awayTeamName :  awayTeamName,
                  leagueName: leagueName,
                  matchYear: matchYear,
                  matchNum: matchNum,
                  domain: hostInfo
                }
              }
            } else if(gameState === 'live') {
              translatedKeyObjectForGamePackage = {
                title : {
                  key : 'meta.title.cricket.multination.gamepackage.game.in',
                  fullScore : fullScore,
                  homeTeamName : homeTeamName,
                  awayTeamName :  awayTeamName,
                  leagueName: leagueName,
                  matchYear: matchYear,
                  matchNum: matchNum,
                  domain: hostInfo
                },
                description : {
                  key : 'meta.description.cricket.multination.gamepackage.game.in',
                  homeTeamName : homeTeamName,
                  awayTeamName :  awayTeamName,
                  leagueName: leagueName,
                  matchYear: matchYear,
                  matchNum: matchNum,
                  domain: hostInfo
                }
              }
            } else {
              if(matchSummary.indexOf('by') !== -1) {
                matchSummaryText = matchSummary.substring(matchSummary.indexOf('by'),matchSummary.length)
                translatedKeyObjectForGamePackage = {
                  title : {
                    key : 'meta.title.cricket.multination.gamepackage.game.post.result',
                    matchWinner : matchWinner,
                    matchLoser :  matchLoser,
                    matchSummaryText: matchSummaryText,
                    homeTeamName: homeTeamName,
                    awayTeamName: awayTeamName,
                    leagueName: leagueName,
                    matchNum: matchNum,
                    domain: hostInfo
                  }
                }
              } else {
                translatedKeyObjectForGamePackage = {
                  title : {
                    key : 'meta.title.cricket.multination.gamepackage.game.post.noresult',
                    matchSummaryText: matchSummary,
                    homeTeamName: homeTeamName,
                    awayTeamName: awayTeamName,
                    leagueName: leagueName,
                    matchNum: matchNum,
                    domain: hostInfo
                  }
                }
              } //result match checks end
              translatedKeyObjectForGamePackage.description = {
                key : 'meta.description.cricket.multination.gamepackage.game.post',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              }
            }//gameState checks end
            translatedKeyObjectForGamePackage.keywords = {
              key: 'meta.keywords.cricket.multination.gamepackage.game',
              homeTeamName: homeTeamName,
              awayTeamName: awayTeamName,
              matchNum: matchNum,
              matchYear: matchYear,
              homeTeamAbbr: homeTeamAbbr,
              awayTeamAbbr: awayTeamAbbr,
              leagueName: leagueName
            }
            break
          case 'scorecard':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.multination.gamepackage.scoreboard',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.multination.gamepackage.scoreboard',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchName: matchName,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.multination.gamepackage.scoreboard',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName
              }
            }
            break
          case 'commentary':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.multination.gamepackage.commentary',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.multination.gamepackage.commentary',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.multination.gamepackage.commentary',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName
              }
            }
            break
          case 'report':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.multination.gamepackage.report',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.multination.cricket.gamepackage.report',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.multination.cricket.gamepackage.report',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName
              }
            }
            break
          case 'video':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.multination.gamepackage.video',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.multination.gamepackage.video',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.multination.gamepackage.video',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName
              }
            }
            break
          case 'statistics':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.multination.gamepackage.statistics',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.multination.gamepackage.statistics',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.multination.gamepackage.statistics',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName
              }
            }
            break
          case 'coverage':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.multination.gamepackage.coverage',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.multination.cricket.gamepackage.coverage',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.multination.gamepackage.coverage',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName
              }
            }
            break
          case 'hawkeye':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.multination.gamepackage.hawkeye',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.multination.gamepackage.hawkeye',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.multination.gamepackage.hawkeye',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName
              }
            }
            break
        } //TOURNEY SWITCH END
      } else {
        switch(pagetypeLower) {
          case 'game':
            if(gameState === 'pregame') {
              translatedKeyObjectForGamePackage = {
                title : {
                  key : 'meta.title.cricket.bilateral.gamepackage.game.pre',
                  homeTeamName : homeTeamName,
                  awayTeamName :  awayTeamName,
                  matchNum: matchNum,
                  domain: hostInfo
                },
                description : {
                  key : 'meta.description.cricket.bilateral.gamepackage.game.pre',
                  homeTeamName : homeTeamName,
                  awayTeamName :  awayTeamName,
                  leagueName: leagueName,
                  matchYear: matchYear,
                  matchNum: matchNum,
                  domain: hostInfo
                }
              }
            } else if(gameState === 'live') {
              translatedKeyObjectForGamePackage = {
                title : {
                  key : 'meta.title.cricket.bilateral.gamepackage.game.in',
                  fullScore : fullScore,
                  homeTeamName : homeTeamName,
                  awayTeamName :  awayTeamName,
                  matchNum: matchNum,
                  domain: hostInfo
                },
                description : {
                  key : 'meta.description.cricket.bilateral.gamepackage.game.in',
                  homeTeamName : homeTeamName,
                  awayTeamName :  awayTeamName,
                  leagueName: leagueName,
                  matchYear: matchYear,
                  matchNum: matchNum,
                  domain: hostInfo
                }
              }
            } else {
              if(matchSummary.indexOf('by') !== -1) {
                matchSummaryText = matchSummary.substring(matchSummary.indexOf('by'),matchSummary.length)
                translatedKeyObjectForGamePackage = {
                  title : {
                    key : 'meta.title.cricket.bilateral.gamepackage.game.post.result',
                    matchWinner : matchWinner,
                    matchLoser :  matchLoser,
                    matchSummaryText: matchSummaryText,
                    homeTeamName: homeTeamName,
                    awayTeamName: awayTeamName,
                    matchNum: matchNum,
                    domain: hostInfo
                  }
                }
              } else {
                translatedKeyObjectForGamePackage = {
                  title : {
                    key : 'meta.title.cricket.bilateral.gamepackage.game.post.noresult',
                    matchSummaryText: matchSummary,
                    homeTeamName: homeTeamName,
                    awayTeamName: awayTeamName,
                    matchNum: matchNum,
                    domain: hostInfo
                  }
                }
              } //result match checks end
              translatedKeyObjectForGamePackage.description = {
                key : 'meta.description.cricket.bilateral.gamepackage.game.post',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              }
            }//gameState checks end
            translatedKeyObjectForGamePackage.keywords = {
              key: 'meta.keywords.cricket.bilateral.gamepackage.game',
              homeTeamName: homeTeamName,
              awayTeamName: awayTeamName,
              matchYear: matchYear,
              matchNum: matchNum,
              homeTeamAbbr: homeTeamAbbr,
              awayTeamAbbr: awayTeamAbbr,
              leagueName: leagueName
            }
            break
          case 'scorecard':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.bilateral.gamepackage.scoreboard',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.bilateral.gamepackage.scoreboard',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchName: matchName,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.bilateral.gamepackage.scoreboard',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName,
                matchYear: matchYear
              }
            }
            break
          case 'commentary':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.bilateral.gamepackage.commentary',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.bilateral.gamepackage.commentary',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.bilateral.gamepackage.commentary',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName
              }
            }
            break
          case 'report':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.bilateral.gamepackage.report',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.bilateral.gamepackage.report',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.bilateral.gamepackage.report',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName,
                matchYear: matchYear,
              }
            }
            break
          case 'video':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.bilateral.gamepackage.video',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.bilateral.gamepackage.video',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.bilateral.gamepackage.video',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName,
                matchYear: matchYear
              }
            }
            break
          case 'statistics':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.bilateral.gamepackage.statistics',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.bilateral.gamepackage.statistics',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.bilateral.gamepackage.statistics',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName,
                matchYear: matchYear,
              }
            }
            break
          case 'coverage':
            translatedKeyObjectForGamePackage = {
              title : {
              key : 'meta.title.cricket.bilateral.gamepackage.coverage',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.bilateral.gamepackage.coverage',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.bilateral.gamepackage.coverage',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName,
                matchYear: matchYear
              }
            }
            break
          case 'hawkeye':
            translatedKeyObjectForGamePackage = {
              title : {
                key : 'meta.title.cricket.bilateral.gamepackage.hawkeye',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                matchNum: matchNum,
                matchYear: matchYear,
                domain: hostInfo
              },
              description : {
                key : 'meta.description.cricket.bilateral.gamepackage.hawkeye',
                homeTeamName : homeTeamName,
                awayTeamName :  awayTeamName,
                leagueName: leagueName,
                matchYear: matchYear,
                matchNum: matchNum,
                domain: hostInfo
              },
              keywords : {
                key: 'meta.keywords.cricket.bilateral.gamepackage.hawkeye',
                homeTeamName: homeTeamName,
                awayTeamName: awayTeamName,
                matchNum: matchNum,
                homeTeamAbbr: homeTeamAbbr,
                awayTeamAbbr: awayTeamAbbr,
                leagueName: leagueName,
                matchYear: matchYear
              }
            }
            break
          } //NON-TOURNEY SWITCH END
        }
    
    gamePackageMetaObject.titleText = translate(edition, translatedKeyObjectForGamePackage.title) || ''
    gamePackageMetaObject.metaDescriptionText = translate(edition, translatedKeyObjectForGamePackage.description) || ''
    gamePackageMetaObject.metaKeywordsText = translate(edition, translatedKeyObjectForGamePackage.keywords) || ''
  
    return gamePackageMetaObject
  }
}
export default metahelpers


// WEBPACK FOOTER //
// ../app/lib/transform/parsers/cricket/gamepackage/metahelpers.js